$(window).on("load",function(){
	$("body").removeClass("preload");
});
$(function(){

	var body = $('body');

	//SVGスプライト
	$.ajax({
		type: 'get',
		url: '/wp/wp-content/themes/reivalue/assets/svg/icons.svg'//ここにパスを入れる（環境に合わせて変更）
	}).done(function(data) {
		var svg = $(data).find('svg');
		body.prepend(svg);
	});

	//スクロールアニメーション
	$('.animate').scrolla({
		mobile: true, // モバイルの有効・無効
		once: true, // 発火は１度だけか、視界に入るたびに発火させるか
		animateCssVersion: 4 // used animate.css version (3 or 4)
	});

	//ページ内スクロール
	$.smooziee();

	//スクロールしたらクラスを付与
	$(window).scroll(function () {
		if ($(this).scrollTop() > 160) {
			body.addClass("scroll");
		} else {
			body.removeClass("scroll");
		}
	});

	//スクロール上下でクラスを付与
	var beforePos = 0;//スクロールの値の比較用の設定
	function ScrollAnime() {
		var elemTop = 100
		// var elemTop = $('#area-2').offset().top;//#area-2の位置まできたら
		var scroll = $(window).scrollTop();
		//ヘッダーの出し入れをする
		if(elemTop > scroll || 0 > scroll - beforePos){
			body.addClass("scroll_up");
			body.removeClass('scroll_down');
		}else {
			body.addClass("scroll_down");
			body.removeClass('scroll_up');
		}
		beforePos = scroll;//現在のスクロール値を比較用のbeforePosに格納
	}
	// 画面をスクロールをしたら動かしたい場合の記述
	$(window).on('scroll', function(){
		ScrollAnime();
	});
	// ページが読み込まれたらすぐに動かしたい場合の記述
	$(window).on('load', function () {
		ScrollAnime();
	});

	//グロナビ開閉
	$('.header_menu_btn').on('click', function () {
		body.toggleClass('menu_open');
		return false;
	});

	$('.header_menu_content a').on('click', function () {
		body.removeClass('menu_open');
		// return false;
	});

    //閉じるボタン
    // $('.header_ac_close').on('click', function () {
    //     body.removeClass('menu_open');
    //     body.removeClass('search_open');
    // });

    //メニュー名以外の部分をクリックで閉じる
    // $('.layer').on('click', function () {
    //     body.removeClass('menu_open');
    //     // body.removeClass('search_open');
    // });

	//アコーディオン
	$('.ac_trigger').on('click', function () {
		if($(this).hasClass('open')){
			$(this).removeClass('open');
		} else {
			$(this).addClass('open');
		}
		$(this).next(".ac_content").slideToggle();
	});

	//動画ポップアップ
    // $('.modalVideoBtn').modalVideo({channel: 'youtube'});

	//スマホ・PCのみ
	$(window).on('load resize', function(){
	// $(window).on('load', function(){
		var w = $(window).width();
		if (w <= 768) {
			//スマホ時
		} else {
			//PC時
		}
	});

	//タブ切り替え
    $(".tab_label").on("click",function(){
		var $th = $(this).index();
		$(this).parent().find(".tab_label").removeClass("active");
		$(this).parents().next().find(".tab_panel").removeClass("active");
		$(this).addClass("active");
		$(this).parents().next().find(".tab_panel").eq($th).addClass("active");
	});

	//トップページのみ
	if($('.home').length){
	}

	//MVスライド
	const mv_swiper = new Swiper('.home_v_swiper', {
		allowTouchMove: false,
		parallax: true,
		loop: true,
		effect: 'fade',
		fadeEffect: {
    		crossFade: true,
  		},
		speed: 2000,
		autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            waitForTransition: false,
        },
        slidesPerView: 1,
        on: {
            slideChangeTransitionStart: function () {
                if($('.swiper-slide-active').hasClass("slide01")){
                	$('.home_v_swiper').removeClass("active02").removeClass("active03");
                    $('.home_v_swiper').addClass('active01');
                } else if($('.swiper-slide-active').hasClass("slide02")){
                	$('.home_v_swiper').removeClass("active01").removeClass("active03");
                    $('.home_v_swiper').addClass('active02');
                } else if($('.swiper-slide-active').hasClass("slide03")){
                	$('.home_v_swiper').removeClass("active01").removeClass("active02");
                    $('.home_v_swiper').addClass('active03');
                }
            },
        },
    });

	//パララックス 上移動
	const elem = document.querySelector(".parallax_up");
	if (elem !== null) {
		let target = document.getElementsByClassName("parallax_up");
			let parallaxConfig = {
				delay: 0, // スクロール止めてから動く秒数
				orientation: "up", // 動く方向
				scale: 1.3, // 動く大きさ
				overflow: true,
			};
		const parallax_instance = new simpleParallax(target, parallaxConfig);
	}

	//パララックス 下移動
	const elem02 = document.querySelector(".parallax_down");
	if (elem02 !== null) {
		let target = document.getElementsByClassName("parallax_down");
			let parallaxConfig = {
				delay: 0, // スクロール止めてから動く秒数
				orientation: "down", // 動く方向
				scale: 1.3, // 動く大きさ
				overflow: true,
			};
		const parallax_instance = new simpleParallax(target, parallaxConfig);
	}

	//サブメニュー スクロール位置変更 スマホ時
	if($('.nav_ul').length){
		const thisWidth = $(".nav_ul .active").position().left;
		// console.log(thisWidth);
		const headerNavBox = $(".nav_ul_wrap");
		headerNavBox.delay(1000).animate({scrollLeft: thisWidth});
	}

	//カウントアップ
	// var scroll;
	// var winH = $(window).height();
	// $(window).on("load scroll", function () {
	// 	$(".js-num").each(function(){
	// 		scroll = $(window).scrollTop();
	// 		var objTop = $(this).offset().top;
	// 		// var countStart = $(this).hasClass('animate__animated');
	// 		if(scroll >= objTop - winH){
	// 		// if(countStart) {
	// 			if ($(this).hasClass('keta2')) {
	// 				var rounding = 2;
	// 			} else if ($(this).hasClass('keta1')) {
	// 				var rounding = 1;
	// 			} else {
	// 				var rounding = 0;
	// 			}
	// 			$(this).numerator( {
	// 				easing: 'linear', // アニメーションの動き
	// 				duration: 1000, // アニメーションの時間
	// 				toValue: $(this).attr("data-num"), // どこまでカウントアップするか
	// 				delimiter: ',', // ３桁ごとに区切る値
	// 				rounding: rounding // 小数点以下の桁数
	// 			});
	// 	    }
	//     });
    // });


	//棒グラフ（会社情報）
	if($('#myChart').length){

		var chartEl1 = document.getElementById("myChart");
		var chartFlag1 = false;

		// 1つ目のグラフ
		var chartFunc1 = function() {
			var ctx = ctx = document.getElementById('myChart');
		      	// ctx.canvas.height = 200;
			chart = new Chart(ctx, {
				type: 'bar',
				data: {
					labels: ['2018年', '2019年', '2020年', '2021年', '2022年', '2023年', '2024年', '2025年(予定)'],
					datasets: [{
						label: '売上（単位：百万円）',
						data: [37, 86, 357, 432, 539, 934, 1500, 2500],
						borderWidth: 0,
						backgroundColor: 'rgba(209, 62, 64, 0.9)',
						// barThickness: 50
					}]
				},
				options: {
					maintainAspectRatio: false, // アスペクト比を維持しない
					responsive: true, // レスポンシブに対応する
					scales: {
						y: {
							suggestedMin: 0,
							suggestedMax: 1400,
							ticks: {
		              			stepSize: 200,
		            		},
		            		beginAtZero: true
						}
					},
					plugins: {// pluginsの中に
						legend: {
							// position: 'top',
							// align: 'start',
							display: false,
						},
						tooltip: {
							enabled: false,
						},
						datalabels: {
					       	anchor: 'end',
			                align: 'top',
			                formatter: function(value, context) {
			                    return value;
			                }
				      	},
					},
				},
				plugins: [
        			ChartDataLabels,
    			],
			});
		};

		// スクロール処理
		var graphAnim = function() {
			var wy = window.pageYOffset,
				//wb = wy + screen.height - 300, // スクリーンの最下部位置を取得
				wb = wy + window.innerHeight, // ブラウザの最下部位置を取得
		      	// チャートの位置を取得
				chartElPos1 = wy + chartEl1.getBoundingClientRect().top;
				// chartElPos2 = wy + chartEl2.getBoundingClientRect().top;

			// チャートの位置がウィンドウの最下部位置を超えたら起動
			if ( wb > chartElPos1 && chartFlag1 == false ) {
				setTimeout(function(){
					chartFunc1();
					chartFlag1 = true;
				},1000);
			}
		  	// if ( wb > chartElPos2 && chartFlag2 == false ) {
			// 	chartFunc2();
			// 	chartFlag2 = true;
			// }
		};

		window.addEventListener('load', graphAnim); // 読み込み時の処理
		window.addEventListener('scroll', graphAnim); // スクロール時の処理

		// const ctx = document.getElementById('myChart');
		// new Chart(ctx, {
		// 	type: 'bar',
		// 	data: {
		// 		labels: ['2018年', '2019年', '2020年', '2021年', '2022年', '2023年', '2024年(予定)'],
		// 		datasets: [{
		// 			label: 'label',
		// 			data: [37, 86, 357, 432, 539, 934, 1200],
		// 			borderWidth: 1
		// 		}]
		// 	},
		// 	options: {
		// 		scales: {
		// 			y: {
		// 				suggestedMin: 0,
		// 				suggestedMax: 1400,
		// 				ticks: {
        //           			stepSize: 200,
        //         		}
		// 				// beginAtZero: true
		// 			}
		// 		},
		// 		plugins: {// pluginsの中に
		// 			legend: {
		// 				display: false
		// 			}
		// 		}
		// 	}
		// });

	}

	//タイマー設定
	$(".view_timer").each(function(index, target) {
		var startDate = $(this).attr("data-start-date");
		var endDate = $(this).attr("data-end-date");
		var nowDate = new Date();
		if (startDate) {
			startDate = new Date(startDate);
		} else {
			startDate = nowDate;
		}
		if (endDate) {
			endDate = new Date(endDate);
		}
		if (startDate <= nowDate && (!endDate || nowDate <= endDate)) {
			$(this).show();
		} else {
			$(this).hide();
		}
	});

});